import { gql } from "@apollo/client";

export const AuthQueries = {
  FETCH_PERMISSIONS: gql`
    query {
      authoring_permissionList(pagePath: "")
    }
  `,
  FETCH_BRAND_DETAILS: gql`
    query {
      authoring_getBrandDetails
    }
  `,
};
